'use client'
import React from 'react'
import MyImage from '../../myImage'
import CricketPitch from '@/assets/images/cricket-pitch.svg'
import CricketPitchLight from '@/assets/images/cricket-pitch-light.svg'

interface venueBowlingProps {
  data: {
    nWicketsPace: number
    nWicketsSpin: number
  }
}

function VenueBowling({ data }: venueBowlingProps) {
  const pacePercentage = ((data?.nWicketsPace / (data?.nWicketsPace + data?.nWicketsSpin)) * 100).toFixed(2)
  const spinPercentage = ((data?.nWicketsSpin / (data?.nWicketsPace + data?.nWicketsSpin)) * 100).toFixed(2)

  return (
    <div className='mt-12 text-center'>
      <h6 className='text-sm md:text-lg mb-4 text-center text-textOffWhite font-medium'>Pace vs Spin on Venue</h6>
      <div className='flex items-center justify-center gap-3 mb-8'>
        <div className='text-right'>
          <p className='text-sm md:text-xl font-semibold text-textOffWhite'>
            Pace
            <span
              className={`block ${data?.nWicketsPace < data?.nWicketsSpin ? 'text-textRed' : 'text-textGreen'}`}
            >{`${data?.nWicketsPace} Wkt`}</span>
          </p>
          <p className='mt-2 text-xs font-semibold md:text-base text-textOffWhite'>{`${pacePercentage}%`}</p>
        </div>
        <div className='w-[198px] md:w-[415px] flex rounded-md overflow-hidden'>
          <div
            className={`h-2 ${data?.nWicketsPace < data?.nWicketsSpin ? 'bg-textRed' : 'bg-textGreen'}`}
            style={{ width: `${pacePercentage}%` }}
          ></div>
          <div
            className={`h-2 ${data?.nWicketsPace > data?.nWicketsSpin ? 'bg-textRed' : 'bg-textGreen'}`}
            style={{ width: `${spinPercentage}%` }}
          ></div>
        </div>
        <div className='text-left'>
          <p className='text-sm md:text-xl font-semibold text-textOffWhite'>
            Spin
            <span
              className={`block ${data?.nWicketsPace > data?.nWicketsSpin ? 'text-textRed' : 'text-textGreen'}`}
            >{`${data?.nWicketsSpin} Wkt`}</span>
          </p>
          <p className='mt-2 text-xs font-semibold md:text-base text-textOffWhite'>{`${spinPercentage}%`}</p>
        </div>
      </div>

      <MyImage width={936} height={103} className='mx-auto dark:block hidden' src={CricketPitch} />
      <MyImage width={936} height={103} className='mx-auto dark:hidden block' src={CricketPitchLight} />
    </div>
  )
}

export default VenueBowling
